import React, { useState } from "react";
import MaterialIcon from "../MaterialIcon";

const DropdownOption = ({ option, index, onClick, highlighted, optionRefs, onDelete }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <li
      ref={(el) => (optionRefs.current[index] = el)}
      className={`dropdown-option d_flex justify_between align_center  ${highlighted ? "highlighted" : ""}`}
      onMouseDown={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ position: "relative" }}
    >
      {option.name}
      {isHovered && (
        <MaterialIcon
          name={"delete"}
          className="font_size_small"
          onMouseDown={(e) => {
            e.stopPropagation();
            onDelete(option.id);
          }}
        />
      )}
    </li>
  );
};

export default DropdownOption;
